import React from 'react';

import { CustomsInstructionEditDisplay } from '@components/utilities/Bookings/CustomsInstructionEditDisplay';
import { useSearch } from '@hooks/next/useSearch';
import { z } from 'zod';

export const CustomsInstruction: React.FC = () => {
  const {
    search: { d2dNo },
  } = useSearch(
    z.object({
      d2dNo: z.string(),
    }),
  );

  return <CustomsInstructionEditDisplay d2dNo={d2dNo} />;
};
